@if(dataSource){
    <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor" class="schema-tree">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [cdkContextMenuTriggerFor]="c_menu" (cdkContextMenuOpened)="onitemSelected(node)">
            <button mat-icon-button [disabled]="true" [attr.aria-label]="'Toggle ' + (node.title || node.elementId)">
                <mat-icon class="mat-icon-rtl-mirror text-color-disabled">
                    {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <span class="material-symbols-outlined me-2 cursor-pointer">
                folder
            </span>
            <span class="mt-1 cursor-pointer">{{node.title || node.elementId}}</span>
        </mat-tree-node>
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodeToggle
            [cdkTreeNodeTypeaheadLabel]="node.title || node.elementId" [cdkContextMenuTriggerFor]="c_menu" (cdkContextMenuOpened)="onitemSelected(node)" 
            class="mat-tree-node"
            [attr.data-mat-tree-node-level]="tree._getLevel(node)+'px'" [style]="(hasChild(tree._getLevel(node)!, node)) ? '--level:'+ tree._getLevel(node)+'px;' : '--level: 0px'">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + (node.title || node.elementId)">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            <span class="material-symbols-outlined me-2 cursor-pointer">
                {{tree.isExpanded(node) ? 'folder_open' : 'folder'}}
            </span>
            <span class="mt-1 cursor-pointer">{{node.title || node.elementId}}</span>
            @if (node.isLoading()) {
                <mat-progress-bar
                    mode="indeterminate"
                    class="tree-progress-bar"></mat-progress-bar>
            }
        </mat-tree-node>

        <!-- <mat-nested-tree-node *matTreeNodeDef="let node" [cdkContextMenuTriggerFor]="c_menu" (cdkContextMenuOpened)="onitemSelected(node)">
            <div class="mat-tree-node">{{node.title || node.elementId}}</div>
        </mat-nested-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodeToggle
            [cdkTreeNodeTypeaheadLabel]="node.title || node.elementId" [cdkContextMenuTriggerFor]="c_menu" (cdkContextMenuOpened)="onitemSelected(node)">
            <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + (node.title || node.elementId)">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                </button>
                <mat-icon class="material-symbols-outlined">
                    {{tree.isExpanded(node) ? 'folder_open' : 'folder'}}
                </mat-icon>
                {{node.title || node.elementId}}
                @if (node.isLoading()) {
                    <mat-progress-bar
                        mode="indeterminate"
                        class="tree-progress-bar"></mat-progress-bar>
                }
            </div>
            <div [class.schema-tree-invisible]="!tree.isExpanded(node)" role="group">
                <ng-container matTreeNodeOutlet></ng-container>
            </div>
        </mat-nested-tree-node>-->

    </mat-tree> 

}

<ng-template #c_menu>
    <context-menu (result)="sendResult($event)" [schemaTree]="selectedItem!"></context-menu>
</ng-template>
